import { useQuery } from '@tanstack/react-query';
import { keyResultService } from '../../services/keyResultService';

/**
 * Hook for fetching key results by objective ID
 * @param objectiveId - The ID of the objective
 * @returns Query result with key results data
 */
export function useKeyResultsQuery(objectiveId: string | undefined) {
  return useQuery({
    queryKey: ['keyResults', objectiveId],
    queryFn: async () => {
      if (!objectiveId) {
        return [];
      }
      return await keyResultService.getByObjective(objectiveId);
    },
    enabled: !!objectiveId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
